/**
 * Las acciones que el agente puede proponer. UNA sola lista, compartida.
 *
 * 🔴 VIVE AQUÍ, Y NO EN EL BACKEND, POR LO QUE COSTÓ TENERLA EN DOS SITIOS.
 * El formulario de prompts del front tenía su propio array escrito a mano, y se
 * quedó viejo sin que nadie lo notara: `cancel_assignment` se añadió al catálogo
 * del backend en septiembre y nunca llegó a la pantalla. Consecuencia real —
 * quien escribía un prompt NO PODÍA marcar «cancelar tarea», así que el prompt
 * salía con una lista blanca que no la incluía y el modelo dejaba de ver la
 * herramienta. No fallaba nada: simplemente el agente no cancelaba nunca, y
 * desde fuera parecía que desobedecía el prompt.
 *
 * Con la lista aquí, cada acción nueva aparece sola en el formulario.
 *
 * Las etiquetas son las de la UI, en español. Los valores son los del enum de
 * `aiplans`/`aiactions`: cambiarlos invalida los planes ya guardados.
 */
const AI_ACTION_TYPES = {
  SEND_WHATSAPP: 'send_whatsapp',
  // AR: el modelo no redacta ni elige plantilla, solo decide SI hoy toca.
  SEND_WHATSAPP_TEMPLATE: 'send_whatsapp_template',
  SEND_EMAIL: 'send_email',
  // AR: enciende la secuencia de correo. No manda nada al momento, pero a
  // partir de ahi los envios salen solos con la cadencia de la empresa — o sea
  // que es MENOS reversible que un correo suelto, no mas.
  START_AR_EMAIL_SEQUENCE: 'start_ar_email_sequence',
  SEND_SMS: 'send_sms',
  CREATE_ANNOTATION: 'create_annotation',
  CREATE_FOLLOW_UP_ASSIGNMENT: 'create_follow_up_assignment',
  // Cancelar una tarea que el mensaje nuevo deja obsoleta. Es la pareja de la
  // de arriba: el agente sabía crear seguimientos pero no cerrarlos, así que un
  // «Repetir WhatsApp sin respuesta» seguía vivo aunque el deudor hubiera
  // respondido. Solo cancela; nunca borra.
  CANCEL_ASSIGNMENT: 'cancel_assignment',
  UPDATE_EXPEDIENT_STATUS: 'update_expedient_status',
};

const AI_ACTION_TYPE_VALUES = Object.values(AI_ACTION_TYPES);

/** Lo que lee una persona al elegir qué puede hacer un prompt. */
const AI_ACTION_LABELS = {
  [AI_ACTION_TYPES.SEND_WHATSAPP]: 'Enviar WhatsApp (texto libre — recobro)',
  [AI_ACTION_TYPES.SEND_WHATSAPP_TEMPLATE]: 'Enviar plantilla de WhatsApp (AR)',
  [AI_ACTION_TYPES.SEND_EMAIL]: 'Enviar email',
  [AI_ACTION_TYPES.START_AR_EMAIL_SEQUENCE]: 'Arrancar secuencia de email (AR)',
  [AI_ACTION_TYPES.SEND_SMS]: 'Enviar SMS',
  [AI_ACTION_TYPES.CREATE_ANNOTATION]: 'Crear anotacion',
  [AI_ACTION_TYPES.CREATE_FOLLOW_UP_ASSIGNMENT]: 'Crear tarea de seguimiento',
  [AI_ACTION_TYPES.CANCEL_ASSIGNMENT]: 'Cancelar tarea',
  [AI_ACTION_TYPES.UPDATE_EXPEDIENT_STATUS]: 'Actualizar estado del expediente',
};

module.exports = {
  AI_ACTION_TYPES,
  AI_ACTION_TYPE_VALUES,
  AI_ACTION_LABELS,
};
